// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"06072c58","453":"51b20bab","455":"8f40daa9"}[chunkId] + ".chunk.js";
};